'use client';
import MuiDrawer from '@mui/material/Drawer';
import { styled } from '@mui/material/styles';

export const BaseDrawer = styled(MuiDrawer)();
